import * as React from "react"
import {
  Input as BaseInput,
  InputSkeleton as BaseInputSkeleton,
  PresentationInputButton as BasePresentationInputButton,
  presentation_input_padding_classes,
} from "../ui/input"

export const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  (props, ref) => {
    return <BaseInput {...props} ref={ref} />
  }
)

export const InputSkeleton = BaseInputSkeleton
export const PresentationInputButton = BasePresentationInputButton
export { presentation_input_padding_classes }

Input.displayName = "Input"
